import moment, { Moment } from 'moment';
import cookies from '../utils/cookies';

type THeader = {
  authorization: string
  'Content-Type'?: string
};

export const headers = (type?:string) => {
  let result: THeader = { 'authorization': cookies.get('token') ? `Bearer ${cookies.get('token')}` : '' };
  type && (result['Content-Type'] = type);
  return result;
}

export const configDateRangeAnt = {
  startDate: moment().clone().subtract(13, 'days') as Moment, 
  endDate:  moment().clone() as Moment, 
  minDate: moment().clone().subtract(89, 'days') as Moment
}